module.exports = __webpack_public_path__ + "img/g1-ShortVideo.0efcae3a.png";